import config from 'react-global-configuration';
import { getLocale } from './locale';

const api = {
    fetchData(objectName) {
        const BASE_URL = config.get('MathleticsLibraryGatewayUrl');
        const getBooksApiUrl = `${BASE_URL}/api/${objectName}`;
        return fetch(getBooksApiUrl, {
            headers: {
                AuthToken: config.get('token'),
                Locale: getLocale() || 'en'
            }
        })
        .then(data => data.json());
    }
};

export default api;
